import { Sun } from '@snack-uikit/loaders';
import cn from 'classnames';
import { PropsWithChildren } from 'react';

import s from './styles.module.scss';

type LoadingOverlayProps = PropsWithChildren<{ isLoading?: boolean; loaderClassName?: string; blurClassName?: string }>;

export function LoadingOverlay({ isLoading, children, blurClassName, loaderClassName }: LoadingOverlayProps) {
  return (
    <div className={s.overlay}>
      <div
        className={cn(
          s.blur,
          {
            [s.display_loader]: isLoading,
          },
          blurClassName,
        )}
      />
      {/* TODO mifrate to Spinner component */}
      <Sun
        size='m'
        className={cn(
          s.loader,
          {
            [s.display_loader]: isLoading,
          },
          loaderClassName,
        )}
      />
      {children}
    </div>
  );
}
